module.exports = __webpack_public_path__ + "img/temperature-arrow-up.56125839.svg";